export const GroupIndexSceneTranslation = {
  fi: {
    GroupIndexScene: {
      title: 'Ryhmät',
      add: 'Luo ryhmä',
      maxGroups: 'Yrityksellä voi olla enintään 20 ryhmää.',
    },
  },
};
